/*
 * Copyright (C) 2016 Spanning Cloud Apps LLC. All rights reserved.
 */
import './confirmModal.tpl.html';

/**
 * Module for the confirm modal.
 */
angular
  .module('shared.confirmModal', [])
  /**
   * Confirm Modal controller. Controller for the confirmModal.tpl.html template.
   */
  .controller(
    'ConfirmModalCtrl',
    function (
      $scope,
      $filter,
      $uibModalInstance,
      confirmText,
      confirmTextKey,
      confirmButtonTextKey,
      cancelButtonTextKey,
      titleTextKey
    ) {
      /**
       * Function to get the confirm box text.
       * @returns {String} - The text of the confirm modal body.
       */
      $scope.getConfirmText = function () {
        if (confirmText) {
          return confirmText;
        }

        var key = confirmTextKey || 'CONFIRM_RESTORE_EXIT';
        return $filter('i18n')(key);
      };

      /**
       * Function to get the confirm box confirm button text.
       * @returns {String} - The text of the confirm button.
       */
      $scope.getConfirmButtonText = function () {
        var key = confirmButtonTextKey || 'CONFIRM';
        return $filter('i18n')(key);
      };

      /**
       * Function to get the confirm box cancel button text.
       * @returns {String} - The text of the cancel button.
       */
      $scope.getCancelButtonText = () => {
        const textKey = cancelButtonTextKey || 'CANCEL';
        return $filter('i18n')(textKey);
      };

      $scope.getTitle = function () {
        var key = titleTextKey || 'EXIT_RESTORE';
        return $filter('i18n')(key);
      };

      /**
       * Function to cancel out of the model.
       */
      $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
      };

      /**
       * Function called when confirm is clicked.
       * Will return true to the parent window, which means to exit wizard flow.
       */
      $scope.confirm = function () {
        $uibModalInstance.close(true);
      };
    }
  )
  .factory('confirmModalUtils', ($uibModal) => ({
    openConfirmModal: (options) => {
      const promise = $uibModal.open({
        templateUrl: 'shared/modal/confirmModal.tpl.html',
        controller: 'ConfirmModalCtrl',
        windowClass: options.windowClass || 'sbsf-confirm-modal-window',
        backdrop: options.backdrop || 'static',
        resolve: {
          confirmText: () => options.confirmText,
          confirmTextKey: () => options.confirmTextKey,
          confirmButtonTextKey: () => options.confirmButtonTextKey,
          cancelButtonTextKey: () => options.cancelButtonTextKey,
          titleTextKey: () => options.titleTextKey
        }
      }).result;

      if (options.doNotCatch) {
        return promise;
      }

      return promise.catch(() => {
        return false; // Not confirmed
      });
    }
  }));
